import isEmpty from 'lodash/isEmpty';

/* eslint-disable camelcase */
export default ({
  item_id = null,
  item_name = null,
  item_properties = null,
  remaining_qty = null,
  exchange_eligibility = null,
  return_eligibility = null,
  return_reason_codes = null,
  item_eligibilities = null,
}) => ({
  itemId: item_id,
  itemName: item_name,
  itemProperties: item_properties,
  itemQuantity: remaining_qty,
  exchangeEligibility: !isEmpty(item_eligibilities)
    ? item_eligibilities?.exchange?.is_eligible
    : exchange_eligibility,
  exchangeMessage: item_eligibilities?.exchange?.message,
  exchangeMessageToken: item_eligibilities?.exchange?.message_token,
  returnEligibility: !isEmpty(item_eligibilities)
    ? item_eligibilities?.return?.is_eligible
    : return_eligibility,
  returnMessage: item_eligibilities?.return?.message,
  returnMessageToken: item_eligibilities?.return?.message_token,
  claimEligibility: Boolean(item_eligibilities?.claim?.is_eligible),
  claimMessage: item_eligibilities?.claim?.message,
  claimMessageToken: item_eligibilities?.claim?.message_token,
  returnReasonCodes: return_reason_codes,
});
